import { GetStaticProps } from 'next'

import { NewtClient } from '@/utils/NewtClient'

export { CalendarPage as default } from '@/components/enpages/Ir/Calendar'

export const getStaticProps: GetStaticProps = async () => {
  const client = new NewtClient()

  const items = await client.fetchIrCalendar()
  
  return {
    props: {
      items,
    },
  }
}
